module.exports = __webpack_public_path__ + "static/img/picture21.468f3055.png";